














import { Component, Vue, Prop } from "@/shared/vuepack";
import { Address, ContactInformation, HsabExpenseResponse } from "@/shared/types";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";

@Component({})
export default class AccountHolderExpensePayee extends Vue {
  contactInfoStore = useContactInfoStore();

  mounted () {
    const args = { username: this.username, partnerId: this.partnerId };
    this.contactInfoStore.getContactInformation(args);
  }
  @Prop({ required: true })
  username: string;

  @Prop({ required: true })
  partnerId: number;

  @Prop()
  expense: HsabExpenseResponse;

  get nameToDisplay () {
    if (this.expense.isPayToPayee) {
      return this.expense.payeeName;
    } else {
      return `${this.contactInfoStore.contactInformation.firstName} ${this.middleInitial(this.contactInfoStore.contactInformation)} ${this.contactInfoStore.contactInformation.lastName}`;
    }
  }
  middleInitial (contact: ContactInformation) {
    if (contact.middleInitial) {
      return contact.middleInitial;
    }
    return "";
  }
  get accountToDisplay () {
    if (this.expense.isPayToPayee) {
      return this.expense.payeeMemberNumber;
    } else {
      return "";
    }
  }

  get addressToDisplay (): Address {
    let result: Address = {
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: ""
    };
    if (this.expense.isPayToPayee) {
      result.addressLine1 = this.expense.payeeAddress1;
      result.addressLine2 = this.expense.payeeAddress2;
      result.city = this.expense.payeeCity;
      result.state = this.expense.payeeStateCode;
      result.zip = this.expense.payeeZipCode;
    } else if (this.contactInfoStore.contactInformation
        && this.contactInfoStore.contactInformation.mailingAddress) {
      result = this.contactInfoStore.contactInformation.mailingAddress;
    }

    return result;
  }

  get showSendPaymentTo () {
    return !isNullEmptyOrUndefined(this.nameToDisplay);
  }

  get showAccountNumber () {
    return !isNullEmptyOrUndefined(this.accountToDisplay);
  }

  get showAddress () {
    return !isNullEmptyOrUndefined(this.addressToDisplay);
  }
}
